// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exp-search-wrapper {
  /* Dimensions réduites au départ */
  width: 40px;
  height: 40px;

  /* Transition de la largeur sur 0.3s */
  transition: width 0.5s ease;

  /* Flex pour aligner input et bouton sur la même ligne */
  display: flex;
  align-items: center;
  justify-content: space-between;

  /* Un petit style de base */
  border: none;  
  /* border: 2px solid #ccc; */
  border-radius: 20px;
  padding-left: 12px; /* Un peu de marge horizontale */
  /* padding: 0; */
  box-sizing: border-box;

  /* Empêche le texte d'être visible quand c'est fermé */
  overflow: hidden;
}
.parentHeaderShopSeller {
  position: "absolute";
  color: 'black';
  left: "20px"; 
  top: "30%";
  display: "flex";
  align-items: 'left';
  gap: '16px'; /* espace entre les deux divs */
  width: "100%",
}

.autoWidthHeaderShopSeller {
   /* Inline-block ou flex-shrink:0 pour prendre la place du texte */
   display: inline-block;
   white-space: nowrap;   /* Empêche le retour à la ligne, la largeur suit le texte */
   font-size: 24px;
   font-weight: bold;
   color: black;
   left: 1px; 
   top: 30%;
   transform: translateY(-50%);
   /* Pas de width fixée => la div s'adapte au contenu */

}

.autoWidthHeaderShopSeller.expanded {
  /* Largeur quand c'est agrandi */
  /* border: 2px solid #ccc; */
  overflow: hidden;
  width: 70px;
}

.exp-search-wrapper.expanded {
  /* Largeur quand c'est agrandi */
  border: 2px solid #ccc;
  width: 100%;
}

/* Le champ de saisie */
.exp-input {
  flex: 1 1;  
  border: none;       /* Supprime la bordure par défaut */
  outline: none;      /* Supprime le highlight au focus (pour la démo) */
  opacity: 0;         /* Invisible tant que pas "expanded" */
  transition: opacity 0.5s ease;
  font-size: 16px;
}

.exp-search-wrapper.expanded .exp-input {
  /* Apparaît lorsque le conteneur est expanded */
  opacity: 1;
}

/* Le bouton icône */
.exp-btn {
  /* left: 0; */
  /* margin: 0; */
  padding: 3px;
  background: none;
  border: none;
  cursor: pointer;
  color: #555;
  font-size: 1.3rem;
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/includes/Layout/ExpandingSearch/ExpandingSearch.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,WAAW;EACX,YAAY;;EAEZ,sCAAsC;EACtC,2BAA2B;;EAE3B,wDAAwD;EACxD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B,2BAA2B;EAC3B,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB,EAAE,gCAAgC;EACpD,gBAAgB;EAChB,sBAAsB;;EAEtB,sDAAsD;EACtD,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,WAAW,EAAE,+BAA+B;EAC5C;AACF;;AAEA;GACG,iEAAiE;GACjE,qBAAqB;GACrB,mBAAmB,IAAI,2DAA2D;GAClF,eAAe;GACf,iBAAiB;GACjB,YAAY;GACZ,SAAS;GACT,QAAQ;GACR,2BAA2B;GAC3B,qDAAqD;;AAExD;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,SAAO;EACP,YAAY,QAAQ,mCAAmC;EACvD,aAAa,OAAO,kDAAkD;EACtE,UAAU,UAAU,sCAAsC;EAC1D,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,aAAa;AACf","sourcesContent":[".exp-search-wrapper {\n  /* Dimensions réduites au départ */\n  width: 40px;\n  height: 40px;\n\n  /* Transition de la largeur sur 0.3s */\n  transition: width 0.5s ease;\n\n  /* Flex pour aligner input et bouton sur la même ligne */\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  /* Un petit style de base */\n  border: none;  \n  /* border: 2px solid #ccc; */\n  border-radius: 20px;\n  padding-left: 12px; /* Un peu de marge horizontale */\n  /* padding: 0; */\n  box-sizing: border-box;\n\n  /* Empêche le texte d'être visible quand c'est fermé */\n  overflow: hidden;\n}\n.parentHeaderShopSeller {\n  position: \"absolute\";\n  color: 'black';\n  left: \"20px\"; \n  top: \"30%\";\n  display: \"flex\";\n  align-items: 'left';\n  gap: '16px'; /* espace entre les deux divs */\n  width: \"100%\",\n}\n\n.autoWidthHeaderShopSeller {\n   /* Inline-block ou flex-shrink:0 pour prendre la place du texte */\n   display: inline-block;\n   white-space: nowrap;   /* Empêche le retour à la ligne, la largeur suit le texte */\n   font-size: 24px;\n   font-weight: bold;\n   color: black;\n   left: 1px; \n   top: 30%;\n   transform: translateY(-50%);\n   /* Pas de width fixée => la div s'adapte au contenu */\n\n}\n\n.autoWidthHeaderShopSeller.expanded {\n  /* Largeur quand c'est agrandi */\n  /* border: 2px solid #ccc; */\n  overflow: hidden;\n  width: 70px;\n}\n\n.exp-search-wrapper.expanded {\n  /* Largeur quand c'est agrandi */\n  border: 2px solid #ccc;\n  width: 100%;\n}\n\n/* Le champ de saisie */\n.exp-input {\n  flex: 1;  \n  border: none;       /* Supprime la bordure par défaut */\n  outline: none;      /* Supprime le highlight au focus (pour la démo) */\n  opacity: 0;         /* Invisible tant que pas \"expanded\" */\n  transition: opacity 0.5s ease;\n  font-size: 16px;\n}\n\n.exp-search-wrapper.expanded .exp-input {\n  /* Apparaît lorsque le conteneur est expanded */\n  opacity: 1;\n}\n\n/* Le bouton icône */\n.exp-btn {\n  /* left: 0; */\n  /* margin: 0; */\n  padding: 3px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #555;\n  font-size: 1.3rem;\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
